import type { LibraryEditor } from "./use-library-editor"

import { AdvancedSection } from "./advanced-section"
import { BasicsSection } from "./basics-section"
import { ConnectionSection } from "./connection-section"
import { ContentSection } from "./content-section"
import { ExtraDataSection } from "./extra-data-section"
import { IndexingSection } from "./indexing-section"
import { SourceSection } from "./source-section"

type LibraryEditorFormProps = {
  editor: LibraryEditor
  embeddingModels: Array<{ id: string; displayName: string }>
  /** Whether the hosting dialog is open (gates the routes query). */
  active: boolean
}

/**
 * The shared library editor body: one scrolling column of collapsible sections, only the ones
 * that apply to the selected source type. Both the create and the edit dialog render this.
 */
export function LibraryEditorForm({ editor, embeddingModels, active }: LibraryEditorFormProps) {
  const has = (section: (typeof editor.sections)[number]) => editor.sections.includes(section)

  return (
    <div className="space-y-3">
      {has("basics") && <BasicsSection editor={editor} />}
      {has("source") && <SourceSection editor={editor} />}
      {has("connection") && <ConnectionSection editor={editor} />}
      {has("content") && <ContentSection editor={editor} />}
      {has("extraData") && <ExtraDataSection editor={editor} />}
      {has("indexing") && <IndexingSection editor={editor} embeddingModels={embeddingModels} />}
      {has("advanced") && <AdvancedSection editor={editor} enabled={active} />}
    </div>
  )
}
